import { adminRoutes } from 'app/constants/routes';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  AdvancePayor,
  AdvanceRelationship,
  Advances,
  MisdirectedPayments,
  Reports,
  TriumphLoadAdvancePayor,
  TriumphLoadAdvanceRelationship,
  TriumphLoadAdvances,
  UnreconciledFunds,
  UnreconciledFundsPayor,
} from './ReportsRouteComponents';

export const reportsRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: Reports,
    path: adminRoutes.reports,
  },
  {
    Component: Advances,
    path: `${adminRoutes.advances}/payors`,
  },
  {
    Component: AdvancePayor,
    path: `${adminRoutes.advances}/payors/:id`,
  },
  {
    Component: AdvanceRelationship,
    path: `${adminRoutes.advances}/relationships/:id`,
  },
  {
    Component: MisdirectedPayments,
    path: adminRoutes.misdirectedPayments,
  },
  {
    Component: TriumphLoadAdvances,
    path: `${adminRoutes.triumphLoadAdvances}/payors`,
  },
  {
    Component: TriumphLoadAdvancePayor,
    path: `${adminRoutes.triumphLoadAdvances}/payors/:id`,
  },
  {
    Component: TriumphLoadAdvanceRelationship,
    path: `${adminRoutes.triumphLoadAdvances}/relationships/:id`,
  },
  {
    Component: UnreconciledFunds,
    path: `${adminRoutes.unreconciledFunds}/payors`,
  },
  {
    Component: UnreconciledFundsPayor,
    path: `${adminRoutes.unreconciledFunds}/payors/:id`,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
